import {
  Component,
  computed,
  input,
  output,
} from '@angular/core'

import { FilterParams } from '../shared/utilities/http-params'
import { IdrColumnSpec } from './idr-columns'
import { sortBy } from 'lodash'

type ColumnSpecSortFn = (columnSpec: IdrColumnSpec) => string | number

const sortFunctions: readonly ColumnSpecSortFn[] = [
  columnSpec => {
    switch (columnSpec.columnType) {
      case 'required':
        return 0
      case 'default':
        return 1
      default:
        return 2
    }
  },
  columnSpec => columnSpec.friendlyName,
]

@Component({
  selector: 'app-idr-filter-column-selector',
  imports: [],
  template: `
    <select
        #select
        class='form-select'
        [disabled]="row().name === 'operating_date'"
        (change)="onChange($event)"
    >
      <option value='' [selected]="name()===''">(select column)</option>
      @for (spec of columnSpecSelections(); track spec.field) {
        <option [value]="spec.field" [selected]="name()===spec.field">{{ spec.friendlyName }}</option>
      }
    </select>
  `,
  styles: `
    select {
      width: 100%;
    }
  `,
})
export class IdrFilterColumnSelectorComponent {
  readonly row = input.required<FilterParams>()
  readonly selectedFields = input.required<readonly string[]>()
  readonly columnSpecs = input.required<readonly IdrColumnSpec[]>()

  readonly update = output<string>()

  protected readonly name = computed(() => this.row().name)

  protected readonly columnSpecSelections = computed(() =>
    sortBy(this.columnSpecs().filter(columnSpec => {
      if (columnSpec.field === this.row().name) {
        return true
      } else {
        return !this.selectedFields().includes(columnSpec.field)
      }
    }), sortFunctions),
  )

  protected onChange({ target }: Event) {
    this.update.emit((target as HTMLSelectElement).value)
  }
}
